module.exports = __webpack_public_path__ + "static/smash-match-3a45dbd458b8164f1a5ca5ee55ac058e.png";